'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SkeletonBase = require('./SkeletonBase');

var _SkeletonBase2 = _interopRequireDefault(_SkeletonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};
var getSize = function getSize(value) {
  return isNumber(value) ? value + 'px' : value;
};

var SkeletonTextWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'SkeletonLoadWrapper__SkeletonTextWrapper'
})(['position:relative;width:', ';'], function (_ref) {
  var width = _ref.width;
  return getSize(width);
});

var SkeletonTextInner = (0, _styledComponents2.default)(_SkeletonBase2.default).withConfig({
  displayName: 'SkeletonLoadWrapper__SkeletonTextInner'
})(['height:', ';left:0;position:absolute;top:50%;transform:translateY(-50%);width:100%;'], function (_ref2) {
  var height = _ref2.height;
  return getSize(height);
});

var SkeletonLoadWrapper = function SkeletonLoadWrapper(_ref3) {
  var isLoading = _ref3.isLoading,
      children = _ref3.children,
      widths = _ref3.widths,
      heights = _ref3.heights,
      rest = _objectWithoutProperties(_ref3, ['isLoading', 'children', 'widths', 'heights']);

  if (isLoading) {
    return _react2.default.createElement(
      'div',
      null,
      widths.map(function (width, index) {
        return _react2.default.createElement(
          'div',
          { key: index, className: index ? 'm-top-1' : '' },
          _react2.default.createElement(
            SkeletonTextWrapper,
            { width: width },
            '\xA0',
            _react2.default.createElement(SkeletonTextInner, _extends({
              height: heights[index],
              use: 'on-shade'
            }, rest))
          )
        );
      })
    );
  }

  return children;
};

SkeletonLoadWrapper.propTypes = {
  children: _react.PropTypes.node,
  isLoading: _react.PropTypes.bool,
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};

SkeletonLoadWrapper.defaultProps = {
  isLoading: false,
  widths: ['100%'],
  heights: ['0.75em']
};

exports.default = SkeletonLoadWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/loading/SkeletonLoadWrapper.js
// module id = 599
// module chunks = 3 4